
/**
Default behaviour. Will display fa-icon question-circle
<tooltip
  id="some-id"
  tooltip-text="This is the tooltip"
  lighthouse-article="ax1z35a"
/>

Use with a default slot.
Note! The div must have a size e.g. dont use float on the inner element
<tooltip
  id="some-id"
  tooltip-text="This is the tooltip"
  lighthouse-article="ax1z35a"
>
  <div>The tooltip will be displayed when you hover this</div>
</tooltip>

 Use a custom popover

 <tooltip id="some-id">
  <div>The tooltip will be displayed when you hover this</div>
<template v-slot:popover>
This will now be the popover
</template>
</tooltip>
*/

import Vue from 'vue';

declare global {
  interface Window {
    Lighthouse: any;
  }
}

export default Vue.extend({
  props: {
    id: {
      type: String,
      required: false,
    },
    lighthouseArticle: {
      type: String,
      default: '',
    },
    tooltipText: {
      type: String,
      default: '',
    },
    placement: {
      type: String,
      default: 'top',
    },
    disableStickyness: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      rand: Math.random()
        .toString(36)
        .substring(7),
    };
  },
  computed: {
    triggers() {
      if (this.disableStickyness) {
        return ['hover', 'focus'];
      }
      return ['hover', 'focus', 'click'];
    },
  },
  methods: {
    openLighthouseArticle(event) {
      event.preventDefault();
      window.Lighthouse.showButton();
      window.Lighthouse.show();
      window.Lighthouse.navigate('article', this.lighthouseArticle);
    },
  },
});
